import firebase from "firebase";
import router from "@/router/index.js";
const dbconnection = process.env.VUE_APP_DB_COLLECTION_ID;
const dbconnectionKey = process.env.VUE_APP_DB_COLLECTION_KEY;
const state = {
  worklogs: [],
  worklog: {},
  executeData: {},
  options: [],
  savedTasks: [],
  materials: [],
  closedWorklogs: [],
  worklogKey: {},
  tempTasks: [],
  tempTask: {},
  tempMaterials: [],
  tempMaterial: {},
  tempWorklog: {},
  clientsCompany: {}
};
const getters = {
  getWorklogKey(state) {
    return state.worklogKey;
  },
  getWorklogs(state) {
    return state.worklogs;
  },
  getClosedWorklogs(state) {
    return state.closedWorklogs;
  },
  getWorklog(state) {
    return state.worklog;
  },
  getExecuteData(state) {
    return state.executeData;
  },
  getOptions(state) {
    return state.options;
  },
  getTasks(state) {
    return state.savedTasks;
  },
  getMaterials(state) {
    return state.materials;
  },
  getTempTasks(state) {
    return state.tempTasks;
  },
  getTempMaterials(state) {
    return state.tempMaterials;
  },
  getTempWorklog(state) {
    return state.tempWorklog;
  }
};
const mutations = {
  setClientsCompany(state, payload) {
    state.clientsCompany = payload;
  },
  setTempWorklog(state, payload) {
    state.tempWorklog = payload;
  },
  removeTempTasks(state) {
    state.tempTasks.pop();
  },
  setTempTasks(state, payload) {
    state.tempTasks.push(payload);
  },
  setTempMaterials(state, payload) {
    state.tempMaterials.push(payload);
  },
  setWorklogKeySet(state, payload) {
    state.worklogKey = payload;
  },
  setWorklogs(state, payload) {
    state.worklogs = payload;
  },
  setClosedWorklogs(state, payload) {
    state.closedWorklogs = payload;
  },
  setWorklog(state, payload) {
    state.worklog = payload;
  },
  setExecuteData(state, payload) {
    state.executeData = payload;
  },
  setOptions(state, payload) {
    state.options = payload;
  },
  addTasks(state, payload) {
    state.savedTasks.push(payload);
  },
  setSavedTasks(state, payload) {
    state.savedTasks = payload;
  },
  addMaterials(state, payload) {
    state.materials = payload;
  },
  setMaterials(state, payload) {
    state.materials = payload;
  }
};
const actions = {
  getAllWorklogs({ commit }, payload) {
    const arr = [];
    commit("setLoading", true);
    var query = firebase.firestore().collection(dbconnection);
    if (payload.companyName) {
      query = query.where("customer", "==", payload.companyName);
    }
    query.get().then(snapshot => {
      snapshot.docs.forEach(doc => {
        var data = doc.data();
        if (payload.closedTickets) {
          if (data.status === "Closed") {
            arr.push(data);
          }
        } else {
          if (data.status !== "Closed") {
            arr.push(data);
          }
        }
      });
    });
    if (payload.closedTickets) {
      commit("setClosedWorklogs", arr);
    } else {
      commit("setWorklogs", arr);
    }
    commit("setLoading", false);
  },
  addNewWorklog({ commit, getters, dispatch }, payload) {
    commit("setLoading", true);
    var additionalOptions = payload.additionalOptions
      ? payload.additionalOptions
      : {};
    var worklogNumber = getters.getWorklogKey;
    const name = payload.customer.companyName;
    payload.dateTicketWasClosed = 0;
    payload.customer = name;
    var tempKey = "";
    if (worklogNumber.key.toString().length > 0) {
      var keys = {
        "1": "RN-000",
        "2": "RN-00",
        "3": "RN-0"
      };
      tempKey = keys[worklogNumber.key.toString().length] + worklogNumber.key;
    }
    payload.worklogNumber = tempKey;
    firebase
      .firestore()
      .collection(dbconnection)
      .doc(payload.worklogNumber)
      .set(payload)
      .then(() => {
        firebase
          .firestore()
          .collection(dbconnectionKey)
          .doc(worklogNumber.docId)
          .update({ key: worklogNumber.key + 1 });
      })
      .finally(() => {
        var route =
          additionalOptions && additionalOptions.redirect
            ? additionalOptions.redirect
            : "/dashboard";
        if (additionalOptions && additionalOptions.sendEmail) {
          dispatch("sendMail", {
            subject: "Otvoren je novi nalog " + payload.worklogNumber,
            html:
              "<p> Klijent " +
              payload.customer +
              " je otvorio novi radni nalog " +
              payload.worklogNumber +
              "</p>"
          });
        }
        router.push(route);
        commit("setLoading", false);
      });
  },
  getOptions({ commit }) {
    commit("setLoading", true);
    firebase
      .firestore()
      .collection("options")
      .onSnapshot(snapshot => {
        commit("setOptions", snapshot.docs[0].data());
      });
    commit("setLoading", false);
  },
  saveChanges({ commit, dispatch }, payload) {
    const worklogUpdate = {
      contactPerson: payload.contactPerson,
      customer: payload.customer,
      dateTicketWasOpened: payload.dateTicketWasOpened,
      phoneNumber: payload.phoneNumber,
      problemDescription: payload.problemDescription,
      status: "Active",
      typeOfProblem: payload.typeOfProblem,
      worklogNumber: payload.worklogNumber,
      tasks: payload.tasks,
      materials: payload.materials,
      taskInProgress: payload.taskInProgress
    };
    commit("setLoading", true);
    firebase
      .firestore()
      .collection(dbconnection)
      .doc(payload.worklogNumber)
      .set(worklogUpdate, { merge: true })
      .then(() => {
        dispatch("getAllWorklogs", { closedTickets: false });
        commit("setLoading", false);
        router.push("/dashboard");
      });
  },
  closeWorklog({ commit, dispatch }, payload) {
    commit("setLoading", true);
    firebase
      .firestore()
      .collection(dbconnection)
      .doc(payload.worklogNumber)
      .set(
        {
          status: "Closed",
          dateTicketWasClosed: payload.dateTicketWasClosed,
          tasks: payload.tasks,
          materials: payload.materials
        },
        { merge: true }
      )
      .then(() => {
        //firebase.firestore().collection('users').where()
        dispatch("getAllWorklogs", { closedTickets: false });
      })
      .finally(() => {
        // dispatch("sendMail", {
        //   subject: payload.worklogNumber + " je zatvoren !",
        //   html:
        //     "<p> Klijent " +
        //     payload.customer +
        //     " je otvorio novi radni nalog " +
        //     payload.worklogNumber +
        //     "</p>"
        // });
        commit("setLoading", false);
        router.push("/dashboard");
      });
  },
  deleteWorklog({ commit, dispatch }, payload) {
    commit("setLoading", true);
    firebase
      .firestore()
      .collection(dbconnection)
      .doc(payload)
      .delete()
      .then(() => {
        // router.go(0);
        dispatch("getAllWorklogs", { closedTickets: false });
        commit("setLoading", false);
      })
      .catch(err => err);
  },
  updatedAllOptions({ commit }, payload) {
    if (payload.typeOfProblem) {
      payload.prevOpt.knownProblems.push(payload.typeOfProblem);
    }
    if (payload.location) {
      payload.prevOpt.location.push(payload.location);
    }
    if (payload.units) {
      payload.prevOpt.units.push(payload.units);
    }
    if (payload.workTime) {
      payload.prevOpt.workTime.push(payload.workTime);
    }

    commit("setLoading", true);
    firebase
      .firestore()
      .collection("options")
      .doc(process.env.VUE_APP_COUNTERY_KEY_ID)
      .update(payload.prevOpt)
      .then(() => {
        router.push("/options");
        commit("setLoading", false);
      });
  },
  useWorklogKey({ commit }) {
    firebase
      .firestore()
      .collection(dbconnectionKey)
      .onSnapshot(snapshot => {
        const docId = snapshot.docs[0].id;
        if (snapshot.docs[0].data().key === 0) {
          commit("setWorklogKeySet", { docId: docId, key: 1 });
        } else {
          commit("setWorklogKeySet", {
            docId: docId,
            key: snapshot.docs[0].data().key
          });
        }
      });
  },
  changeWorklogStatus({ commit, dispatch }, payload) {
    commit("setLoading", true);
    payload.status = "Active";
    firebase
      .firestore()
      .collection(dbconnection)
      .doc(payload.worklogNumber)
      .set(payload, { merge: true })
      .then(() => {
        dispatch("getAllWorklogs", { closedTickets: true });
        dispatch("getAllWorklogs", { closedTickets: false });
        commit("setLoading", false);
      });
    commit("setLoading", false);
  },
  invoiceWorklog({ commit, dispatch }, payload) {
    commit("setLoading", true);
    payload.isInvoiced = true;
    firebase
      .firestore()
      .collection(dbconnection)
      .doc(payload.worklogNumber)
      .set(payload, { merge: true })
      .then(() => {
        dispatch("getAllWorklogs", { closedTickets: false });
        commit("setLoading", false);
      });
  },
  getAllClientsWorklogs({ commit }, payload) {
    const arr = [];
    commit("setLoading", true);
    firebase
      .firestore()
      .collection(dbconnection)
      .where("customer", "==")
      .get()
      .then(snapshot => {
        snapshot.docs.forEach(doc => {
          if (payload) {
            if (doc.data().status === "Closed") {
              arr.push(doc.data());
            }
          } else {
            if (doc.data().status !== "Closed") {
              arr.push(doc.data());
            }
          }
        });
      });
    if (payload) {
      commit("setClosedWorklogs", arr);
    } else {
      commit("setWorklogs", arr);
    }
    commit("setLoading", false);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
